import {connect} from 'react-redux';

import League from '../League.jsx';

function select(state, props) {
    const league = state.application.getIn(['menu', 'leagues', props.leagueId]);

    return {
        ...props,
        league
    };
}

export default connect(select, null, null, false)(League);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/preMatch/League.jsx